import { createAction, props } from '@ngrx/store';
import { ICreateInstituciones, IDeleteInstitucionesResponse, IInstituciones, IUpdateInstituciones, IUpdateInstitucionesResponse } from 'src/app/interfaces/instituciones.interface';

export const GetInstituciones = createAction(
    '[Instituciones] Get Instituciones',
  );

export const GetInstitucionesSuccess = createAction(
    '[Instituciones] Get Instituciones Success',
    props<{instituciones: IInstituciones[]}>()
  );

export const CreateInstituciones = createAction(
    '[Instituciones] Create Instituciones',
    props<{institucion: ICreateInstituciones}>()
  );

export const CreateInstitucionesSuccess = createAction(
    '[Instituciones] Create Instituciones Success',
    props<{institucion: IInstituciones}>()
  );

export const DeleteInstituciones = createAction(
    '[Instituciones] Delete Instituciones',
    props<{id: string}>()
  );

export const DeleteInstitucionesSuccess = createAction(
    '[Instituciones] Delete Instituciones Success',
    props<{institucion: IDeleteInstitucionesResponse}>()
  );

export const UpdateInstituciones = createAction(
    '[Instituciones] Update Instituciones',
    props<{id: string, institucion: IUpdateInstituciones }>()
  );

export const UpdateInstitucionesSuccess = createAction(
    '[Instituciones] Update Programa Success',
    props<{institucion: IUpdateInstitucionesResponse }>()
  );
